module.exports = new __parcel__URL__("b2b-icon-buero.1628c328.png").toString();